// extracted by mini-css-extract-plugin
module.exports = {"questions":"styles_questions__KReNT"};